/**
 * @generated SignedSource<<adde64c1dbcc86729caadde0d662fc43>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Storecast_Dashboard$data = {
  readonly canEdit: boolean;
  readonly defaultTeams: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly id: string;
  readonly widgets: ReadonlyArray<{
    readonly __typename: string;
    readonly id: string;
    readonly note?: {
      readonly " $fragmentSpreads": FragmentRefs<"NoteEdit" | "NoteEditSharedInfo_widgetNote">;
    };
    readonly " $fragmentSpreads": FragmentRefs<"AllWidgets_widget" | "InteractiveWidgetWrapper_widget" | "useWidgetToPos_widget">;
  } | null>;
  readonly " $fragmentType": "Storecast_Dashboard";
};
export type Storecast_Dashboard$key = {
  readonly " $data"?: Storecast_Dashboard$data;
  readonly " $fragmentSpreads": FragmentRefs<"Storecast_Dashboard">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Storecast_Dashboard",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "defaultTeams",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "widgets",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useWidgetToPos_widget"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AllWidgets_widget"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "InteractiveWidgetWrapper_widget"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Note",
              "kind": "LinkedField",
              "name": "note",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NoteEditSharedInfo_widgetNote"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "NoteEdit"
                }
              ],
              "storageKey": null
            }
          ],
          "type": "WidgetNote",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Dashboard",
  "abstractKey": null
};
})();

(node as any).hash = "bfeca57592cfebb44ac0b6a3468949ad";

export default node;
